import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const formatWithOrdinal = (date) => {
    const givenDate = new Date(date);

    // Get day, month, and year
    const day = givenDate.getDate();
    const month = givenDate.toLocaleString('en-US', { month: 'short' });
    const year = givenDate.getFullYear();

    // Add ordinal suffix to the day
    const ordinal = getOrdinalSuffix(day);

    return `${month} ${day}${ordinal}, ${year}`;
};

export const relativeDates = (date) => {
    const now = new Date();
    const givenDate = new Date(date);

    // Normalize to UTC to avoid time zone differences
    const nowUTC = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const givenDateUTC = Date.UTC(givenDate.getFullYear(), givenDate.getMonth(), givenDate.getDate());

    // Calculate the difference in milliseconds
    const timeDiffMs = now - givenDate;
    const timeDiffMinutes = Math.floor(timeDiffMs / (1000 * 60));
    const timeDiffHours = Math.floor(timeDiffMinutes / 60);
    const dayDiff = Math.floor((nowUTC - givenDateUTC) / (1000 * 60 * 60 * 24)); // Convert to days

    // Show "Just now" if the difference is less than a minute
    if (timeDiffMinutes < 1) return 'Just now';

    // Show "X minutes ago" if less than 60 minutes
    if (timeDiffMinutes < 60) return `${timeDiffMinutes} minutes ago`;

    // Show "Today" if it happened today but more than an hour ago
    if (dayDiff === 0) return 'Today';

    // Show "Yesterday" if the difference is 1 day
    if (dayDiff === 1) return 'Yesterday';

    // Show "X days ago" if less than a week
    if (dayDiff < 7) return `${dayDiff} days ago`;

    // Show "Last week" or "X weeks ago" if within a month
    const weekDiff = Math.floor(dayDiff / 7);
    if (dayDiff <= 30) return weekDiff === 1 ? 'Last week' : `${weekDiff} weeks ago`;

    // If the difference is more than 30 days, return the formatted date
    return formatWithOrdinal(date);
};

function getOrdinalSuffix(day) {
    if (day % 10 === 1 && day !== 11) return 'st';
    if (day % 10 === 2 && day !== 12) return 'nd';
    if (day % 10 === 3 && day !== 13) return 'rd';
    return 'th';
}


export function isPastDate(dateString = '') {
    if (!dateString) {
        return false;
    }
    
    const inputDate = dayjs.utc(dateString, 'YYYY-MM-DD');

    // 🌟 ADDED: Check if the resulting date object is valid
    if (!inputDate.isValid()) {
        console.warn(`isPastDate received an invalid date string: ${dateString}`);
        // Decide your policy:
        // - return false: Treat invalid input as 'not in the past'
        // - throw error: Force the calling code to fix the bad data
        return false; 
    }
    
    const today = dayjs.utc().startOf('day');
    return inputDate.isBefore(today, 'day');
}